import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  welcomeMessageContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    height: '100%',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(6),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  welcomeMessageTitle: {
    fontSize: '2rem',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginBottom: theme.spacing(2),
  },
  welcomeMessageSubtitle: {
    textAlign: 'left',
    fontSize: '1.25rem',
    lineHeight: 1.6,
    maxWidth: '600px',
    marginBottom: theme.spacing(2),
  },
  importantText: {
    textAlign: 'left',
    fontSize: '0.9rem',
    color: '#666',
    marginBottom: theme.spacing(2),
  },
  importantText2: {
    textAlign: 'left',
    fontSize: '1.25rem',
    fontWeight: 'bold',
    lineHeight: 1.6,
    maxWidth: '600px',
    marginBottom: theme.spacing(2),
  },
  continueButton: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 4),
    fontSize: '1.25rem',
  },
}));
